module.exports = __webpack_public_path__ + "img/cover-turkiye-is-bankasi-valentines-day.a866602c.jpg";